export default "__VITE_ASSET__7c95cd5f__"